import * as React from 'react';
import { Wizard } from '@common/components/wizard/_components/wizard.component';
import { Summary } from '../../contract/_components/summary/summary.container';
import { ContractPayment } from '../../contract/_components/contract-payment/_components/contract-payment.container';

interface RenewalNoChangesProperties {}

export class RenewalNoChanges extends React.Component<RenewalNoChangesProperties> {
  render() {
    const steps = [{ name: 'Review', component: Summary }, { name: 'Payment', component: ContractPayment }];

    return (
      <>
        <Wizard steps={steps} isRenewal={true} renewalAsIs={true} />
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/renewal/_components/renewal-no-changes.tsx